import { REQUEST_STATUS } from '@/constants/request-status'

export function getStatusLabelById(id: string) {
  const values = Object.values(REQUEST_STATUS)
  const found = values.find((item) => item.id === id)
  if (found) {
    return found.name
  }

  return '--'
}
